module.exports = __webpack_public_path__ + "static/media/envelope.082d92e7.svg";